import styled from '@mui/material/styles/styled'

export const Divider = styled('hr')({
  border: 'none',
  borderBottom: 'solid 1px #ddd',
})
